import { createSlice } from '@reduxjs/toolkit';
import { customSort } from '../../utils/helper';
import { DATE_FORMATS_OPTIONS } from 'pages/user-settings/date-format';
import { FILE_FORMATS_VALUES } from 'pages/user-settings/file-format';
import { CURRENCY_FORMATS_OPTIONS } from 'pages/user-settings/currency-type';

const initialState: any = {
  merchantData: [],
  legalNamesList: [],
  legalNamesInEnglishList: [],
  merchantIDList: [],
  reasonCodeList: [],
  allReasonCodes: [],
  dasmidOptions: [],
  initialFilter: [],
  unCheckedArray: [],
  timeZone: null,
  userPreference: {
    formatType: FILE_FORMATS_VALUES.EXCEL,
    dateFormatType: DATE_FORMATS_OPTIONS.DATE_TIME_AM_PM,
    currencyType: CURRENCY_FORMATS_OPTIONS.USD,
    emailNotifications: {
      chargeback: true,
      statement: true,
      emergencyHoliday: true,
      monthlyPublicHoliday: true,
    },
    transactionList: {
      selected: 'default',
      list: {
        default: {
          order: [],
          unChecked: [],
        },
      },
    },
    statementList: {
      selected: 'default',
      list: {
        default: {
          order: [],
          unChecked: [],
        },
      },
    },
  },
  downloadPreferences: {
    selectedList: 'default',
    sensitiveColumns: false,
    whitelistTransactions: false,
  },
  subsidiaryList: [],
  deepLink: '',
  paymentLoggroup: null,
  salesLeadFilterMerchantData: [],
  salesLeadFilterPartnerData: [],
  releaseTourData: [],
  masterEntityData: [],
  businessLocations: [],
};
// createSlice
export const configSlice: any = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setDasmidOptions: (state, action) => {
      state.dasmidOptions = action.payload;
    },
    setDeepLink: (state, action) => {
      state.deepLink = action.payload;
    },
    setUnCheckedArray: (state, action) => {
      state.unCheckedArray = action.payload;
    },
    setUserPreference: (state, action) => {
      state.userPreference = action.payload;
    },
    setPaymentLoggroup: (state, action) => {
      state.paymentLoggroup = action.payload;
    },
    setMerchantData: (state, action) => {
      state.merchantData = action.payload;

      const legalNameList = action.payload?.map(({ LegalName }: any) => {
        return LegalName;
      });
      state.legalNamesList = customSort(legalNameList);

      const legalNameInEnglishList = action.payload
      ?.map(({ LegalNameInEnglish }: any) => LegalNameInEnglish)
      ?.filter((name: string | null) => !!name); // removes null, undefined, ""
      state.legalNamesInEnglishList = customSort(legalNameInEnglishList);

      const merchantIDList = action.payload?.map(({ MerchantID }: any) => {
        return MerchantID;
      });
      state.merchantIDList = merchantIDList;
    },
    setSalesLeadFilterMerchant: (state, action) => {
      state.salesLeadFilterMerchantData = action?.payload;
    },
    setSalesLeadFilterPartner: (state, action) => {
      state.salesLeadFilterPartnerData = action?.payload;
    },
    setReleaseTourData: (state, action) => {
      state.releaseTourData = action?.payload;
    },
    setReasonCodeList: (state, action) => {
      state.reasonCodeList = action.payload;
      state.allReasonCodes = Object.values(action.payload)?.flat(1);
    },
    setSubsidiaryList: (state, action) => {
      state.subsidiaryList = action.payload;
    },
    setTimeZone: (state, action) => {
    state.timeZone = action.payload;
  },
  setMasterEntityData: (state, action) => {
    state.masterEntityData = action.payload;
  },
  setBusinessLocations: (state, action) => {
    state.businessLocations = action.payload;
  },
  setDownloadPreferences: (state, action) => {
    state.downloadPreferences = {
      ...state.downloadPreferences,
      ...action.payload,
    };
  },
    resetConfigData: state => {
      state.merchantData = [];
      state.legalNamesList = [];
      state.legalNamesInEnglishList = [];
      state.merchantIDList = [];
      state.reasonCodeList = [];
      state.allReasonCodes = [];
      state.dasmidOptions = [];
      state.paymentLoggroup = {};
      state.initialFilter = '';
      state.deepLink = '';
      state.unCheckedArray = [];
      state.listViewConfiguration = [];
      state.subsidiaryList = [];
      state.releaseTourData = [];
      state.masterEntityData = [];
      state.businessLocations = [];
    },
    setInitialFilter: state => {
      state.initialFilter = [];
    },
    resetInitialFilter: state => {
      state.initialFilter = '';
    },
  },
});
export const reasonCodeList = (state: any) => state?.config?.reasonCodeList;
export const allReasonCodes = (state: any) => state?.config?.allReasonCodes;
export const selectTimeZone = (state: any) => state?.config?.timeZone;
export const selectReleaseTourData = (state: any) => state?.config?.releaseTourData;
export const xrayPaymentLoggroup = (state: any) =>
  state?.config?.paymentLoggroup;
export const selectDownloadPreferences = (state:any) =>
  state.config.downloadPreferences;
export const {
  setDeepLink,
  setUnCheckedArray,
  setDasmidOptions,
  setMerchantData,
  setSalesLeadFilterMerchant,
  setReasonCodeList,
  resetConfigData,
  setInitialFilter,
  resetInitialFilter,
  setSubsidiaryList,
  setPaymentLoggroup,
  setSalesLeadFilterPartner,
  setUserPreference,
  setTimeZone,
  setReleaseTourData,
  setDownloadPreferences,
  setMasterEntityData,
  setBusinessLocations,
} = configSlice.actions;
export default configSlice.reducer;
